import {
  SIGN_IN_DETAILS,
  SIGN_IN_REQUEST_SUCCESS,
  SIGN_OUT_REQUEST_SUCCESS,
} from './actionTypes';

export default function reducer(state = null, action) {
  switch (action.type) {
    case SIGN_IN_REQUEST_SUCCESS:
      return action.payload;
    case SIGN_OUT_REQUEST_SUCCESS:
      return null;
    default:
      return state;
  }
}

// actions
export function signIn(user) {
  return {
    type: SIGN_IN_REQUEST_SUCCESS,
    payload: user,
  };
}

export function signInDetails() {
  return {
    type: SIGN_IN_DETAILS,
  };
}

export function signOut() {
  return {
    type: SIGN_OUT_REQUEST_SUCCESS,
  };
}
